export default __webpack_public_path__ + "static/media/전남.dc89ceaf.png";